import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tab from '../../../../components/tabs/Tab';
import Tabs from '../../../../components/tabs/Tabs';
import Smartuploader from '../../../../components/Smartuploader';
import { HigherPlanTag } from '../../../../styles/styled';
import Recordinguploader from '../../../../components/Recordinguploader';
import { getAudioDuration } from '../../../../helpers/episodes';
import styled from 'styled-components';
import styles from '../shared/styles';

window.AudioContext = window.AudioContext || window.webkitAudioContext;

class UploadRecord extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      audioDuration: 0,
    };

    this.setAudioDuration = this.setAudioDuration.bind(this);
    this.onAudioFilepondStart = this.onAudioFilepondStart.bind(this);
    this.onAudioFilepondProcess = this.onAudioFilepondProcess.bind(this);
    this.onRecordingUploaded = this.onRecordingUploaded.bind(this);
    this.renderRecordtitle = this.renderRecordtitle.bind(this);
  }

  setAudioDuration(file) {
    getAudioDuration(file).then(audioDuration => {
      this.setState({ audioDuration });
    });
  }

  onAudioFilepondStart(filepond) {
    const { onUploadStart } = this.props.uploader;
    this.setAudioDuration(filepond.file);
    onUploadStart(filepond);
  }

  onAudioFilepondProcess(error, filepond) {
    if (error) {
      alert('Unable to process your file. ' + error.message);
      return console.log('Unable to process file', error);
    }

    // add the episode to state
    const { filenameWithoutExtension: episodeId } = filepond;
    // console.log('onAudioFilepondProcess', filepond);
    const { onUploadComplete } = this.props.uploader;
    const { audioDuration } = this.state;
    onUploadComplete(`https://app.mysoundwise.com/tracks/${episodeId}.mp3`, audioDuration);
  }

  onRecordingUploaded() {
    const { episodeId, recorder } = this.props;
    const { audioDuration } = this.state;
    const { onRecordingComplete } = recorder;
    onRecordingComplete(`https://app.mysoundwise.com/tracks/${episodeId}.mp3`, audioDuration);
  }

  renderAudioUploader() {
    const { episodeId, uploader } = this.props;
    const { onUploadRemove, onImportRemove, onImportComplete } = uploader;

    return (
      <Smartuploader
        header={
          <React.Fragment>
            Upload Audio<span style={styles.requiredTxt}>*</span>&nbsp;
            <span style={styles.miniSubheaderText}>
              (mp3, mp4, m4a, wav and mov files accepted. If it's a video, we'll convert it into
              audio for you)
            </span>
          </React.Fragment>
        }
        fileuploader={{
          server: {
            process: '/api/uploadv2',
            revert: null,
          },
          onaddfilestart: this.onAudioFilepondStart,
          onprocessfile: this.onAudioFilepondProcess,
          onremovefile: onUploadRemove,
          onerror: onUploadRemove,
          acceptedFileTypes: ['audio/x-m4a', 'audio/*', 'video/*'],
          fileRenameFunction: file => {
            return `${episodeId}${file.extension}`;
          },
          fileMetadataObject: {
            importingAudio: true,
            episodeId,
          },
        }}
        linkuploader={{
          server: '/api/uploadv2',
          serverRemove: false,
          onimporterror: onImportRemove,
          onimportremove: onImportRemove,
          onimportcomplete: onImportComplete,
          metadataObject: {
            importingAudio: true,
            filerename: episodeId,
            episodePropKey: 'url',
            episodeId: episodeId,
          },
        }}
      />
    );
  }

  renderAudioRecorder() {
    const { episodeId, activeTab, recorder } = this.props;
    const { onRecordingRemove } = recorder;

    // make sure to do not render the audio recorder
    // until its visible on the page, to avoid making
    // the wavesurfer canvas disappear
    if (activeTab !== 'record') {
      return null;
    }

    return (
      <Recordinguploader
        server="/api/upload"
        serverRemove={false}
        filename={`${episodeId}.mp3`}
        metadata={{
          episodeId,
        }}
        onprocessrecording={this.setAudioDuration}
        onremovedrecording={onRecordingRemove}
        onuploadcomplete={this.onRecordingUploaded}
        onuploaderror={error => {
          console.log('Error recording upload', error);
        }}
      />
    );
  }

  renderRecordtitle() {
    const { recorder } = this.props;

    if (!recorder.accessible) {
      return (
        <NotAllowedTab>
          <span>Record</span>
          <HigherPlanTag/>
        </NotAllowedTab>
      );
    }

    return null;
  }

  render() {
    const { activeTab, onChangeTab } = this.props;
    return (
      <div className="row" style={styles.rowDivision}>
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <Tabs activeKey={activeTab} onChange={onChangeTab} canChangeActiveKey={true}>
            <Tab eventKey="upload" title="Upload">
              {this.renderAudioUploader()}
            </Tab>
            <Tab eventKey="record" title="Record" customRenderer={this.renderRecordtitle}>
              {this.renderAudioRecorder()}
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

const NotAllowedTab = styled.a`
  cursor: not-allowed !important;

  span:first-child {
    margin-right: 10px;
  }
`;

UploadRecord.propTypes = {
  episodeId: PropTypes.string,
  activeTab: PropTypes.string,
  onChangeTab: PropTypes.func,
  uploader: PropTypes.shape({
    onUploadStart: PropTypes.func,
    onUploadRemove: PropTypes.func,
    onUploadComplete: PropTypes.func,
    onImportRemove: PropTypes.func,
    onImportComplete: PropTypes.func,
  }),
  recorder: PropTypes.shape({
    accessible: PropTypes.bool,
    onRecordingRemove: PropTypes.func,
    onRecordingComplete: PropTypes.func,
  }),
};

UploadRecord.defaultProps = {
  episodeId: '',
  activeTab: 'upload',
  onChangeTab: () => {},
  uploader: {
    onUploadStart: () => {},
    onUploadRemove: () => {},
    onUploadComplete: () => {},
    onImportRemove: () => {},
    onImportComplete: () => {},
  },
  recorder: {
    accessible: true,
    onRecordingRemove: () => {},
    onRecordingComplete: () => {},
  },
};

export default UploadRecord;
